import { render, staticRenderFns } from "./PaymentPixErrorCode.vue?vue&type=template&id=3522be3c&scoped=true"
import script from "./PaymentPixErrorCode.vue?vue&type=script&lang=js"
export * from "./PaymentPixErrorCode.vue?vue&type=script&lang=js"
import style0 from "./PaymentPixErrorCode.vue?vue&type=style&index=0&id=3522be3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522be3c",
  null
  
)

export default component.exports